import { proxy } from 'valtio';

interface WebsocketDebugState {
  /**
   * Ratio of message to drop {0..1}
   * 0 - no dropped message
   * 1 - all messages dropped
   * @default 0
   */
  dropRate: number;

  /**
   * Time to elapse before unacknowledged messages are considered dropped
   * @default 60_000
   */
  dropTimeoutMs: number;
}

export const defaultWebsocketDropRate = 0;
export const defaultWebsocketDropTimeoutMs = 60_000;

export const currentWebsocketDebugState: WebsocketDebugState = proxy({
  dropTimeoutMs: defaultWebsocketDropTimeoutMs,
  dropRate: defaultWebsocketDropRate,
});
